import script from "./AccordionDateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionDateInput.vue?vue&type=script&setup=true&lang=js"

import "./AccordionDateInput.vue?vue&type=style&index=0&id=2c2b1d06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2b1d06"]])

export default __exports__